import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Badge, Form, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { toast } from "react-toastify";

import Head from "../../layout/head/Head";
import Content from "../../layout/content/Content";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Col,
  Icon,
  PreviewAltCard,
  Row,
} from "../../components/Component";

import MyButton from "../../MyComp/UI/form/MyButton";
import MyInput from "../../MyComp/UI/form/MyInput";
import Status from "../../MyComp/UI/form/Status";
import MyDataTable from "../../MyComp/UI/DataTable/MyDataTable";
import ConfirmModal from "../../MyComp/UI/modals/ConfirmModal";

import { createLabCategory, deleteLabCategory, getLabCategory, updateLabCategory } from "../../api/master/indes";
 
import OrderComponent from "../../MyComp/UI/form/OrderComponent";
import DeleteModal from "../../MyComp/UI/modals/DeleteModal";
import useLogout from "../../hooks/useLogout";

const Laboratory = () => {
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    trigger,
    reset,
    formState: { errors },
  } = useForm();

  const { logout } = useLogout();

  // Separate table state from form
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [mode, setMode] = useState("Add");
const [showDeleteModal, setShowDeleteModal] = useState(false);

  const columns = [
    {
      name: "Name",
      selector: (row) => row?.name,
      sortable: true, 
    },
    {
      name: "Order",
      selector: (row) => row?.order,
      sortable: true, 
    },
    {
      name: "Status",
      selector: (row) => row?.status,
      cell: (row) => (
        <div style={{ cursor: "pointer" }} onClick={() => handleToggleStatus(row)}>
          <Badge style={{width:"57px",display:"flex",justifyContent:"center"}} color={row.status ? "success" : "danger"}>{row.status ? "Active" : "Inactive"}</Badge>
        </div>
      ),
      sortable: true, 
      width:"90px"
    },
    {
      name: "Action", 
      cell: (row) => (
        <div><Button outline color="warning" size="xs" onClick={() => handleEdit(row)}>
          <Icon name="edit" />
        </Button>
        {" "}
        <Button outline color="danger" size="xs" onClick={() => handleDeleteClick(row)}>
          <Icon name="trash" onClick={() => handleDeleteClick(row)} />
        </Button></div>
        
      ),
      width:"120px"
        
    },
    
  ];

  useEffect(() => {
    getLabList();
  }, []);

  const getLabList = () => {
    setLoading(true);
    getLabCategory()
      .then((res) => {
        setLoading(false);
        if (res.data.status === true) {
          setTableData(res.data.data);
        } else if (res.data.status === "expired") {
          toast.error(res.data.message);
          logout();
        } else {
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        setLoading(false);
        toast.error(err?.response?.data?.message);
      });
  };
  console.log(tableData, "tabledtaa");
  const onFormSubmit = (formData) => {
    const body = {
      name: formData.name,
      order: Number(formData.order),
      status: formData?.status?.value ?? true,
      ...(mode === "Edit" && { id: selectedRow?.id }),
    };

    setLoading(true);

    const apiCall = mode === "Add" ? createLabCategory(body) : updateLabCategory(body);

    apiCall
      .then((res) => {
        setLoading(false);
        if (res.data.status === true) {
          toast.success(res.data.message);

          if (mode === "Add") {
            const newItem = res.data.data || res.data.newData || null;

            if (newItem && newItem.id) {
              setTableData((prev) => [...prev, newItem]);
            } else {
              getLabList();
            }
          } else {
            setTableData((prev) => prev.map((item) => (item.id === selectedRow.id ? { ...item, ...body } : item)));
          }

          setIsOpen(false);
          setMode("Add");
          reset();
        } else if (res.data.status === "expired") {
          toast.error(res.data.message);
          logout();
        } else {
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        setLoading(false);
        toast.error(err?.response?.data?.message);
      });
  };

  const handleEdit = (row) => {
    window.scrollTo(0, 0);
    console.log(row, "rowedit");
    setSelectedRow(row);
    setIsOpen(true);
    setMode("Edit");

    setValue("name", row.name);
    setValue("order", row.order);
    setValue("status", {
      label: row.status ? "Active" : "Inactive",
      value: row.status,
    });
  };

  const handleToggleStatus = (row) => {
    console.log(row, "rowtoggle");
    setSelectedRow(row);
    setShowModal(true);
  };

  const confirmStatusChange = () => {
    const updatedStatus = !selectedRow.status;
    // setLoading(true);

    updateLabCategory({ id: selectedRow.id, status: updatedStatus })
      .then((res) => {
        setLoading(false);
        if (res.data.status === true) {
          toast.success(res.data.message);

          // Update local table only
          setTableData((prev) =>
            prev.map((item) => (item.id === selectedRow.id ? { ...item, status: updatedStatus } : item))
          );

          setShowModal(false);
        } else if (res.data.status === "expired") {
          toast.error(res.data.message);
          logout();
        } else {
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        setLoading(false);
        toast.error(err?.response?.data?.message);
      });
  };
  const handleDeleteClick = (row) => {
  setSelectedRow(row);
  setShowDeleteModal(true);
};

 
const confirmDelete = () => {
  if (!selectedRow) return;

  setLoading(true);

  deleteLabCategory({ id: selectedRow.id })
    .then((res) => {
      setLoading(false);
      setShowDeleteModal(false);
      if (res.data.status === true) {
        toast.success(res.data.message);
        setTableData((prev) => prev.filter((item) => item.id !== selectedRow.id));
      } else if (res.data.status === "expired") {
        toast.error(res.data.message);
        logout();
      } else {
        toast.error(res.data.message);
      }
    })
    .catch((err) => {
      setLoading(false);
      toast.error(err?.response?.data?.message);
    });
};



  return (
    <>
      <Head title="Laboratory | Master" />
      <Content>
        <BlockHead size="sm" className="mb-0 pb-0">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page tag="h3">
                Manage Laboratory
              </BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <Button
                color="primary"
                outline
                className="me-n1"
                onClick={() => {
                  if (!isOpen) {
                    setIsOpen(true);
                    setMode("Add");
                    reset();
                  } else {
                    setIsOpen(false);
                  }
                }}
              >
                <Icon name={isOpen ? "minus" : "plus"} />
              </Button>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        <Block className="pt-0">
          <Row>
            {isOpen && (
              <PreviewAltCard>
                <Form onSubmit={handleSubmit(onFormSubmit)}>
                  <Row>
                    <Col md="4">
                      <MyInput
                        register={register}
                        watch={watch}
                        setValue={setValue}
                        trigger={trigger}
                        errors={errors}
                        title="Name"
                        name="name"
                        placeholder="Enter lab name"
                        required
                      />
                    </Col>

                    <Col md="4">
                      <OrderComponent
                        register={register}
                        watch={watch}
                        setValue={setValue}
                        trigger={trigger}
                        errors={errors}
                        title="Order"
                        name="order"
                        placeholder="Enter order number"
                        required
                      />
                    </Col>

                    <Col md="4">
                      <Status register={register} watch={watch} title={"Status"} setValue={setValue} trigger={trigger} errors={errors} />
                    </Col>

                    <Col md="3" className="d-flex align-items-end">
                      <MyButton isLoading={loading} mode={mode} />
                    </Col>
                  </Row>
                </Form>
              </PreviewAltCard>
            )}
          </Row>

          <MyDataTable data={tableData} columns={columns} title="Lab List" isLoading={loading} />
        </Block>
      </Content>

<DeleteModal
  showDeleteModal={showDeleteModal}
  setShowDeleteModal={setShowDeleteModal} 
  confirmDelete={confirmDelete}
  selectedRow={selectedRow}
  loading={loading}
/>

      <ConfirmModal
        isOpen={showModal}
        toggle={() => setShowModal(!showModal)}
        onConfirm={confirmStatusChange}
        status={selectedRow?.status}
      />
    </>
  );
};

export default Laboratory;
